import {
  TRADE_ARROWS_FONT_FAMILY,
  TRADE_ARROWS_FONT_URL,
} from "../../positionLines/tradeArrowsFont";
import { AXIS_FONT_SIZE_PX } from "../constants";
import { POSITION_FONT_WEIGHT } from "../overlays/positions/positionConstants";
import { axisFont } from "./axisFont";

// The arrows font is added to the document once for all charts
let tradeArrowsFontLoad = null;

// Direction arrows of position cards: our TradeArrow icons as font glyphs
const loadTradeArrowsFont = () => {
  if (!tradeArrowsFontLoad) {
    const face = new FontFace(TRADE_ARROWS_FONT_FAMILY, `url("${TRADE_ARROWS_FONT_URL}")`);

    document.fonts.add(face);
    tradeArrowsFontLoad = face.load();
  }

  return tradeArrowsFontLoad;
};

/**
 * Canvas text does not wait for web fonts. Calls `onLoaded` once the axis
 * fonts, the font of position pills and cards and the arrows font are ready (or failed), so
 * labels can be measured and drawn again.
 *
 * @param {string} fontFamily
 * @param {() => void} onLoaded
 */
export const loadChartFonts = (fontFamily, onLoaded) => {
  const fonts = [
    axisFont(fontFamily),
    axisFont(fontFamily, true),
    `${POSITION_FONT_WEIGHT} ${AXIS_FONT_SIZE_PX}px ${fontFamily}`,
  ];

  // A font that failed to load leaves its fallback, the labels are drawn with it
  Promise.allSettled([...fonts.map((font) => document.fonts.load(font)), loadTradeArrowsFont()]).then(
    onLoaded,
  );
};
